import {
  teamsLightTheme,
  teamsDarkTheme,
  teamsHighContrastTheme,
  Theme,
} from "@fluentui/react-components";
import { ThemeString } from "../utils/useTeamsContext";

export function getFluentTheme(theme: ThemeString): Theme {
  switch (theme) {
    case "dark":
      return teamsDarkTheme;
    case "contrast":
      return teamsHighContrastTheme;
    default:
      return {
        ...teamsLightTheme,
        colorNeutralBackground3: "#eeeeee",
      };
  }
}
